<template>
<div :class="$style['old-to-new-customer-message']">
    <table>
      <template v-if="!isReject">
        <!-- <pt-message-table-item label="用户姓名">{{customer.userName}}</pt-message-table-item> -->
        <pt-message-table-item label="手机号">{{customer.userMobile}}</pt-message-table-item>
        <pt-message-table-item label="常住地区" v-if="customerType==='NEW'">
          <template v-if="customer.region">
            {{customer.region.provinceName+customer.region.cityName+customer.region.districtName}}
          </template>
          <template v-else>--</template>
        </pt-message-table-item>
        <pt-message-table-item label="CPS合同">
          <template >
            <table cellspacing="0" cellpadding="0"  :class="$style['customer-CPS-message']">
              <tr>
                <th>CPS合同号</th>
                <th>合同姓名</th>
                <th>合同地区</th>
                <th>产品名称</th>
                <th>产品条码</th>
                <template v-if="isNew">
                <th>生产医院</th>
                <th>医院编码</th>
                </template>
                <th>业务员姓名</th>
                <th>业务员工号</th>
              </tr>
              <tr v-for="(item,i) in customer.contractInformation" :key="i">
                <td>{{item.contractCode?item.contractCode:'--'}}</td>
                <td>{{item.motherName?item.motherName:'--'}}</td>
                <td>{{item.cpsRegion?item.cpsRegion:"--"}}</td>
                <td>
                  <div v-for="(etem,index) in item.productInformation" :key="index">
                    {{etem.name?etem.name:"--"}}
                      <!-- {{etem.name?(etem.name+(etem.productCode?("-"+etem.productCode):'')):'--'}} -->
                  </div>
                </td>
                <td>
                  <div v-for="(etem,index) in item.productInformation" :key="index">
                    {{etem.barcode?etem.barcode:"--"}}
                      <!-- {{etem.name?(etem.name+(etem.productCode?("-"+etem.productCode):'')):'--'}} -->
                  </div>
                </td>
                <template v-if="isNew">
                  <td>{{item.birthHospital?item.birthHospital:"--"}}</td>
                  <td>{{item.birthHospitalCode?item.birthHospitalCode:"--"}}</td>
                </template>
                <td>{{item.salesName?item.salesName:"--"}}</td>
                <td>{{item.salesWorkNumber?item.salesWorkNumber:"--"}}</td>
              </tr>
            </table>
            <!-- <div :class="$style['CPS-number']" v-for="(item,i) in customer.contractInformation" :key='i'>
            <div v-for="(etem,index) in item.productInformation" :key="index">
              <span>{{etem.contractCode}}</span><span>{{etem.cpsRegion}}</span><span>{{etem.motherName}}</span><span>{{etem.name?(etem.name+(etem.productCode?("-"+etem.productCode):'')):'--'}}</span>
            </div>
            </div> -->
          </template>
          <!-- <template v-else>
            {{customer.contractInformation&&customer.contractInformation[0]&&customer.contractInformation[0].contractCode}}
          </template> -->
          </pt-message-table-item>
          <pt-message-table-item v-if="customerType==='OLD'" label="奖励轮次">
            <!-- {{customer.rewardCount>=2?"第二轮":"第一轮"}} -->
            {{detail.finalRewardCount}}
          </pt-message-table-item>
        <!-- <pt-message-table-item label="地区">{{customer.cpsRegion}}</pt-message-table-item> -->
        <!-- <template v-if="isNew">
          <pt-message-table-item label="CPS合同号">
            {{customer.contractInformation&&customer.contractInformation[0]&&customer.contractInformation[0].contractCode}}
          </pt-message-table-item>
          <pt-message-table-item label="CPS合同姓名">
            {{customer.contractInformation&&customer.contractInformation[0]&&customer.contractInformation[0].motherName}}
          </pt-message-table-item> -->
          <!-- <pt-message-table-item label="地区">{{customer.cpsRegion}}</pt-message-table-item> -->
         <!-- <pt-message-table-item label="CPS合同地区">{{customer.contractInformation&&customer.contractInformation[0]&&customer.contractInformation[0].cpsRegion}}</pt-message-table-item>
        <pt-message-table-item label="产品名称">{{customer.product_name}}</pt-message-table-item>
        <pt-message-table-item label="产品号">{{customer.product_code}}</pt-message-table-item>
        <pt-message-table-item label="条码">{{customer.bar_code}}</pt-message-table-item>
        <pt-message-table-item label="生产医院">
          {{(customer.contractInformation&&customer.contractInformation[0]&&customer.contractInformation[0].birthHospital)?customer.contractInformation[0].birthHospital:'--'}}
        </pt-message-table-item>
        <pt-message-table-item label="医院编码">
          {{(customer.contractInformation&&customer.contractInformation[0]&&customer.contractInformation[0].birthHospitalCode)?customer.contractInformation[0].birthHospitalCode:'--'}}
        </pt-message-table-item>
        <pt-message-table-item label="业务员姓名">
          {{(customer.contractInformation&&customer.contractInformation[0]&&customer.contractInformation[0].salesName)?customer.contractInformation[0].salesName:'--'}}
        </pt-message-table-item>
        <pt-message-table-item label="业务员工号">
          {{(customer.contractInformation&&customer.contractInformation[0]&&customer.contractInformation[0].salesWorkNumber)?customer.contractInformation[0].salesWorkNumber:'--'}}
        </pt-message-table-item>
        </template> -->
        <pt-message-table-item label="状态">{{customer.reward_status}}</pt-message-table-item>
        <pt-message-table-item label="驳回原因" v-if="isShowRejectReason">{{customer.rejectReason}}</pt-message-table-item>
        <pt-message-table-item label="备注" v-if="isShowRemark">{{customer.remark}}</pt-message-table-item>
        <pt-message-table-item label="发放时间">{{customer.reward_date||"--"}}</pt-message-table-item>
        <pt-message-table-item label="发放人" v-if="customer.rewardStatus!=='NO_REWARD'">{{customer.operatorName}}</pt-message-table-item>
      </template>
        <pt-message-table-item label="返现">
          <template v-if="(!isShowOperation&&!isReject)||type==='OLD'">
              <template v-if="customer.reward&&customer.reward.money">
                  <span :class="$style['money-reward-amount']">{{customer.moneyRewardAmount}}</span>元
                </template>
                <template v-else>--</template>
            </template>
          <template  v-else>
             <wt-input v-model="form.amount" placeholder="请输入返现金额" :class="$style['customer-grant-amount']"  data-vv-as="返现金额" type="number" v-validate="'decimal:2|min_value:0'">
                <el-button slot="append">元</el-button>
              </wt-input>
          </template>
        </pt-message-table-item>
        <pt-message-table-item label="返券">
          <template v-if="(!isReject&&!isShowOperation)||type==='OLD'">
              <template v-if="customer.reward&&customer.reward.couponTotalAmount">
                <span :class="$style['money-reward-amount']">{{customer.couponRewardAmount}}</span>
                <template  v-if="!isShowOperation">元</template>
            </template>
            <template v-else>--</template>
          </template>
            <template v-else>
            <el-button type="primary" plain @click="addCoupons">添加优惠劵</el-button>
            </template>
        </pt-message-table-item>
          <pt-message-table-item label="已选择" v-if="coupon_list&&coupon_list.length>0">
          <div :class="$style['selected-coupon']">
            <template v-if="coupon_list&&coupon_list.length>0">
              <wt-table :list="coupon_list">
                  <template>
                      <el-table-column label="优惠劵:">
                          <template slot-scope="scope">
                              {{scope.row.couponData&&scope.row.couponData.name}}
                          </template>
                      </el-table-column>
                      <el-table-column label="优惠劵内容">
                          <template slot-scope="scope">
                              <div>{{scope.row.discount}}</div>
                              <div>满{{scope.row.thresholdOfAmount}}元可使用</div>
                          </template>
                      </el-table-column>
                      <!-- <el-table-column label="剩余库存（张）">
                          <template slot-scope="scope">
                              {{scope.row.surplusAmount}}
                          </template>
                      </el-table-column> -->
                      <el-table-column label="赠券张数">
                          <template slot-scope="scope">
                              <wt-input v-model="scope.row.amount" v-if="isEditCoupons"   data-vv-as="赠券张数" type="number" v-validate="'required|decimal:0|min_value:0'"></wt-input>
                              <template v-else>{{scope.row.amount}}</template>
                          </template>
                      </el-table-column>
                      <el-table-column label="操作" v-if="isEditCoupons">
                          <template slot-scope="scope">
                          <el-button type="text" @click="deleteCoupon(index,scope.row)">删除</el-button>
                      </template>
                      </el-table-column>
                  </template>
              </wt-table>
             </template>
             <template v-else>未选择任何优惠劵</template>
          </div>
        </pt-message-table-item>
    </table>
      <div class="button-div">
       <el-button type="primary" @click="returnEdit" v-if="isShowReturnEdit">返回修改</el-button>
      </div>
     <el-dialog :visible="is_dialog"  :title="dialog_title" @close="closeDialog" :class="$style['coupon-select-dialog']">
   <coupon-list v-if="is_select_coupon" @selectCouponSubmit="selectCouponSubmit" :couponParams="couponParams"  @close="closeDialog" :selected-coupon="coupon_list"></coupon-list>
 </el-dialog>
</div>
</template>
<script>
import formMixins from 'mixins/form'
import couponList from '../../pt-promotion-coupon/coupon-list'
import { cashCount } from '@/utils/formUtils'
export default {
  mixins: [formMixins],
  components: {
    couponList
  },
  props: {
    customer: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isReward: {
      type: Boolean,
      default: false
    },
    isEditCoupons: {
      type: Boolean,
      default: false
    },
    isReject: {
      type: Boolean,
      default: false
    },
    contentType: {
      type: String,
      default: null
    },
    customerType: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: null
    },
    detail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  computed: {
    // 是否显示选择优惠劵和发放金额的操作
    isShowOperation () {
      return (!this.customer.moneyRewardAmount && !this.customer.couponRewardAmount) || this.customer.rewardStatus === 'NO_REWARD'
    },
    is_dialog: {
      set: function (val) {
        this.is_select_coupon = val
      },
      get: function () {
        return this.is_select_coupon
      }
    },
    isShowReturnEdit () {
      return this.contentType === 'grant' && this.customer.rewardStatus === 'SALES_REJECTED'
    },
    isShowRemark () {
      return this.contentType === 'grant' && (this.customer.rewardStatus !== 'NO_REWARD' && this.customer.rewardStatus !== 'WAITING_FOR_APPROVAL')
    },
    isShowRejectReason () {
      return this.contentType === 'grant' && (this.customer.rewardStatus === 'SALES_REJECTED' || this.customer.rewardStatus === 'REJECTED')
    },
    // 是否显示产品信息（新用户显示）
    isNew () {
      return this.customerType === 'NEW'
    }
  },
  data () {
    return {
      is_select_coupon: false,
      dialog_title: '',
      coupon_list: [],
      couponParams: {
        discountType: 'FIXED_AMOUNT'
      },
      form: {
        amount: this.customer.moneyRewardAmount || this.defualtAmount
      },
      isShowRejectOparetion: false
    }
  },
  watch: {
    form: {
      handler: function (val) {
        this.$emit('formValue', val)
      },
      deep: true,
      immediate: true
    },
    coupon_list: {
      handler: function (val) {
        this.$emit('formValue', this.form)
        let couponTotalAmount = 0
        if (val.length > 0) {
          val.forEach(item => {
            couponTotalAmount = (item.discountCoupon && item.discountCoupon.couponData &&
            item.discountCoupon.couponData.discount && cashCount(item.discountCoupon.couponData.discount, true)) * item.amount
          })
        }
        console.log('couponTotalAmount', couponTotalAmount)
        this.form.coupon_list = JSON.parse(JSON.stringify(val))
      },
      deep: true
    },
    customer: {
      handler: function (val) {
        this.form.amount = this.customer.moneyRewardAmount
        let list = (val.reward && JSON.parse(JSON.stringify(val.reward.discountCoupons))) || []
        if (list && list.length > 0) {
          list.forEach(item => {
            this.coupon_list.push({ ...item.discountCoupon, ...item })
          })
        }
      },
      deep: true,
      immediate: true
    },
    isReject: {
      handler: function (val) {
        if (val) {
          this.form.amount = this.customer.reward && this.customer.reward.money && cashCount(this.customer.reward.money, true)
        }
      },
      immediate: true
    }
  },
  methods: {
    returnEdit () {
      this.$emit('rejectEdit', this.customer, this.customerType)
    },
    deleteCoupon (index, row) {
      this.$confirm('您是否确定删除该脐荐康奖励', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning' }).then(_ => {
        this.coupon_list.splice(index, 1)
      }).catch(_ => {
      })
    },
    addCoupons () {
      this.is_select_coupon = true
      this.dialog_title = '选择优惠劵'
    },
    closeDialog () {
      this.is_dialog = false
    },
    selectCouponSubmit (val) {
      this.is_dialog = false
      this.coupon_list = JSON.parse(JSON.stringify(val))
      this.form.coupon_list = JSON.parse(JSON.stringify(val))
      this.form.discountCoupons = this.coupon_list
    }
  }
}
</script>
<style module lang="less">
@import "~less/var";
.old-to-new-customer-message{
  padding: 0 20px
}
.CPS-number{
  word-break: break-all;
  :global
  span{
    margin-right:15px
  }
}
.old-to-new-{
  padding: 0 20px;
}
.money-reward-amount{
  color: @mainColor;
  font-weight: 600;
  font-size: 17px;
  margin-right: 5px;
}
.customer-grant-amount{
  max-width:300px;
  margin-right: 30px;
}
.selected-coupon{
  padding: 20px;
  background-color: #F9F9F9;
  min-width: 600px;
  :global
  .wt-table{
    *{
      background-color: #F9F9F9;
      .el-input{
        *{
        background-color: #fff;

        }
      }
    }
  }
}

.customer-CPS-message{
  // border:1px solid #F00;
  th{
    padding: 10px;
     border-bottom: 1px solid #ebeef5
  }
  td{
    padding: 10px;
    border-bottom: 1px solid #ebeef5
  }

}
</style>
